import {Component} from '@angular/core';
import {ViewController} from 'ionic-angular';

/**
 * Generated class for the ProfileDeleteAccountModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-profile-delete-account-modal',
    templateUrl: 'profile-delete-account-modal.html',
})
export class ProfileDeleteAccountModalPage {

    public emailSent: boolean;

    constructor(public viewCtrl: ViewController) {
        this.emailSent = false;
    }

    closeModal() {
        this.viewCtrl.dismiss();
    }

    openMail(): boolean {
        let email = "support@tuipoint.com";
        let subject = `Account deletion request for #${localStorage.getItem('tuid')}`;
        location.href = `mailto:${email}?subject=${subject}`;

        this.closeModal();

        return true;
    }

}



// WEBPACK FOOTER //
// ./src/pages/profile-delete-account-modal/profile-delete-account-modal.ts